import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default function initGsapSteps() {
    const elements = document.querySelectorAll(".element123");

    // const timeline = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: ".section-container",
    //         start: "top top",
    //         end: `+=${(elements.length - 1) * 100}% top`,
    //         scrub: 1,
    //         pin: true,
    //         // markers: true,
    //     },
    // });

    elements.forEach((element, index) => {
        const split = new SplitText(element, { type: "words" });
        const words = split.words;

        timeline.from(words, {
            x: 25,
            autoAlpha: 0,
            stagger: 0.04,
            filter: "blur(8px)",
        });

        if (index < elements.length - 1) {
            timeline.to(words, { autoAlpha: 0 }, "+=1");
        }
    });
}
